import { render, staticRenderFns } from "./ChangeDev.vue?vue&type=template&id=38f411c5&"
import script from "./ChangeDev.vue?vue&type=script&lang=js&"
export * from "./ChangeDev.vue?vue&type=script&lang=js&"
import style0 from "./ChangeDev.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports